/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LeagueStatus = {
    DRAFT: 'DRAFT',
    REGISTRATION: 'REGISTRATION',
    ACTIVE: 'ACTIVE',
    PLAYOFFS: 'PLAYOFFS',
    COMPLETED: 'COMPLETED',
    ARCHIVED: 'ARCHIVED'
} as const;
export type LeagueStatus = typeof LeagueStatus[keyof typeof LeagueStatus];


export function instanceOfLeagueStatus(value: any): boolean {
    for (const key in LeagueStatus) {
        if (Object.prototype.hasOwnProperty.call(LeagueStatus, key)) {
            if (LeagueStatus[key as keyof typeof LeagueStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LeagueStatusFromJSON(json: any): LeagueStatus {
    return LeagueStatusFromJSONTyped(json, false);
}

export function LeagueStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeagueStatus {
    return json as LeagueStatus;
}

export function LeagueStatusToJSON(value?: LeagueStatus | null): any {
    return value as any;
}

export function LeagueStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): LeagueStatus {
    return value as LeagueStatus;
}

